module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Db-Fc-Gb-Hc-Ia.6849e1e7.png";